import React, { useState } from 'react';
import styled from 'styled-components';
import { MdViewList, MdCategory } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import ProductCatalog from './ProductCatalog';
import TransactionsOverview from './TransactionsOverview';

const tabs = [
    { key: 'catalog', labelKey: 'ManufacturerProducts.tabs.catalog', icon: <MdViewList /> },
    { key: 'transactions', labelKey: 'ManufacturerProducts.tabs.transactions', icon: <MdCategory /> },
];

const ManufacturerProducts = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('catalog');

    return (
        <Wrapper>
            <Header>
                <Title>{t('ManufacturerProducts.title')}</Title>
                <Subtitle>{t('ManufacturerProducts.subtitle')}</Subtitle>
            </Header>

            <Tabs>
                {tabs.map((tab) => (
                    <TabButton
                        key={tab.key}
                        $active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.icon}
                        <span>{t(tab.labelKey)}</span>
                    </TabButton>
                ))}
            </Tabs>

            <Content>
                {activeTab === 'catalog' && <ProductCatalog />}
                {activeTab === 'transactions' && (
                    <TransactionsOverview />
                )}
            </Content>
        </Wrapper>
    );
};

export default ManufacturerProducts;

const Wrapper = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 1.25rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 1.25rem;
`;

const Title = styled.h1`
    margin: 0;
    color: rgba(130, 22, 146, 1);
`;

const Subtitle = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

const Tabs = styled.div`
    display: flex;
    gap: 0.75rem;
    border-bottom: 1px solid rgba(130, 22, 146, 0.15);
    padding-bottom: 0.625rem;
`;

const TabButton = styled.button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 0.1)' : 'transparent')};
    border: none;
    border-bottom: ${({ $active }) => ($active ? '3px solid rgba(130, 22, 146, 1)' : '3px solid transparent')};
    color: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 1)' : '#444')};
    padding: 0.625rem 0.75rem;
    font-weight: 600;
    cursor: pointer;

    span {
        font-size: 0.95rem;
    }

    svg {
        font-size: 1.2rem;
    }
`;

const Content = styled.div`
    margin-top: 1.25rem;
`;

const Placeholder = styled.div`
    padding: 2.5rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
    border: 1px dashed rgba(130, 22, 146, 0.3);
    border-radius: 12px;
`;
